import React from "react"
import styles from "./error.module.scss"

const Error = () => {
 return <div className={styles.element}>Error</div>
}

export default Error